import React, { useEffect, useState } from 'react'
import './email.css'
import {Link} from 'react-router-dom'
import { Controller, useForm } from 'react-hook-form'
// import { EditorState, convertToRaw } from 'draft-js'
// import draftToHtml from 'draftjs-to-html';
// import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
// import 'draft-js/dist/Draft.css';
// import { Editor } from 'react-draft-wysiwyg'
import Popover from '@mui/material/Popover';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import googleImg from '../../assets/google-logo.png'
import { useDispatch, useSelector } from 'react-redux'
import { storeToken } from '../../state/userSlice'
import { fetchMail } from '../../api'



const clientID = '754518648250-41ksg9cgm3tu40ls9aitb5gt8flc9j90.apps.googleusercontent.com'
const clientSecret = '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'


const columns = [

  { field: 'starred', 
  headerName: 'Starred', 
  width: 50,
  renderCell: (param) => (
    // param.row.starred ? (
      <i class='bx bx-star inbox__datagrid-icon'></i>
    // ): (
    //   <i class='bx bxs-star inbox__datagrid-icon starred'></i>
    // )
  )
  },
  {
      field: 'subject',
      headerName: 'Subject',
      width: 400,
      renderCell: (param) => (
        <Link className="inbox__datagrid-item">
          <h4 className="inbox__datagrid-title">{param.row.from}</h4>
          <span className="inbox__datagrid-subject">{param.row.subject}</span>
        </Link>
      )
  },
  {
      field: 'attachment',
      headerName: 'Attachment',
      width: 80,
      renderCell: (param)=>(
        <i class='bx bx-link-alt inbox__datagrid-icon'></i>
      )
  },
  {
      field: 'date',
      headerName: 'Date',
      width: 120,
      editable: true,
  },
];

const rows = [
  {
      id: 1,
      starred: true,
      from: 'Kazeem Oluwafemi',
      subject: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Necessitatibus',
      attachment: false,
      date: '6/1/2123'
  },
  {
      id: 2,
      starred: false,
      from: 'Kazeem Oluwafemi',
      subject: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Necessitatibus',
      attachment: true,
      date: '6/1/2123'
  },
  {
      id: 3,
      starred: true,
      from: 'Kazeem Oluwafemi',
      subject: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Necessitatibus',
      attachment: false,
      date: '6/1/2123'
  },
  
];


const ComposeMail = () => {
  const [editorState, setEditorState] = useState()
  const [addOn, setAddOn] = useState(false)

  const {
    register,
    handleSubmit,
    formState:{errors},
    control,
    reset
  } = useForm({
    mode: 'onChange'
  })

  const handleEditorState = (val)=>{
    setEditorState(val)
  }

  const handleComposeMail = (data)=>{
    console.log(data)
  }

  return (
    <div className="compose__mail">

      <form onSubmit={handleSubmit(handleComposeMail)}
      className="compose__mail-form">

        {/* MAIL FROM FIELD */}
        <div className="compose__mail-form_item">
          <input type="text" className="compose__mail-form_input" 
          placeholder='From' name='mailfrom' value='oluwafemiayobami2@gmail.com'
          {...register('mailfrom')} readOnly/>
        </div>

        {/* MAIL TO FIELD */}
        <div className="compose__mail-form_item">
          <div className="compose__mail-form-div">
            <input type="text" className="compose__mail-form_input" 
            placeholder='To' name='mailto'
            {...register('mailto',{required: 'This field is required'})}/>
            <button className="compose__mail-form_item-button" 
            type='button' onClick={()=>setAddOn(!addOn)}>
              <i class='bx bx-plus'></i>
            </button>
          </div>
          <span className="compose__mail-form_error">
            {errors.mailto && errors.mailto.message}
          </span>
        </div>

        {/* MAIL CC AND BCC FIELD */}
        {
          addOn && (
            <div className={`compose__mail-form_item-div ${addOn && 'active'}`}>
              <div className="compose__mail-form_item">
                <input type="text" className="compose__mail-form_input" 
                placeholder='Cc' name='mailcc'
                {...register('mailcc')}/>
                <span className="compose__mail-form_error">
                  {errors.mailcc && errors.mailcc.message}
                </span>
              </div>
              <div className="compose__mail-form_item">
                <input type="text" className="compose__mail-form_input" 
                placeholder='Bcc' name='mailbcc'
                {...register('mailbcc')}/>
                <span className="compose__mail-form_error">
                  {errors.bcc && errors.bcc.message}
                </span>
              </div>
            </div>
          )
        }

        {/* MAIL SUBJECT FIELD */}
        <div className="compose__mail-form_item">
          <input type="text" className="compose__mail-form_input" 
          placeholder='Subject' name='mailsubject'
          {...register('mailsubject')}/>
          <span className="compose__mail-form_error">
            {errors.mailsubject && errors.mailsubject.message}
          </span>
        </div>

        {/* MAIL MESSAGE FIELD */}
        <div className="compose__mail-form_item">
          {/* <Controller
          name='mailmessage'
          control={control}
          rules={{required: 'This field is required'}}
          defaultValue={''}
          render={({field})=>(
            <Editor editorClassName='compose__mail-form_editor'
              editorState={editorState}
              onEditorStateChange={(newEditorState)=>{
                handleEditorState(newEditorState)
                field.onChange(draftToHtml(convertToRaw(newEditorState.getCurrentContent())))
              }}
            />
          )}/> */}
          <span className="compose__mail-form_error">
            {errors.mailmessage && errors.mailmessage.message}
          </span>
        </div>
        
        {/* SUBMIT BUTTON */}
        <div className="compose__mail-form_item">
          <button type='subject'
          className="compose__mail-form_button button">
            Send
          </button>
        </div>

      </form>
    </div>
  )
}

// INBOX
const Inbox = ({messagesRows}) => {

  return(
    <div className="inbox">
      <div className="inbox__search">
        <span className='inbox__search-span'>Inbox</span>
        <div className="inbox__search-box">
          <input type="text" className="inbox__search-input" 
          placeholder='Search'/>
          <span><i class='bx bx-search'></i></span>
        </div>
      </div>

      <div className="inbox__table">
        <DataGrid
        // getRowId={(row)=> row.id}
          rows={rows}
          columns={columns}
          initialState={{
          pagination: {
              paginationModel: {
              pageSize: 5,
              },
          },
          }}
          pageSizeOptions={[5]}
          checkboxSelection
          disableRowSelectionOnClick
          getRowHeight={() => 'auto'} 
          sx={{
              maxWidth: {md: '1100px', sm: '600px', xs: '400px'},
              '& .MuiDataGrid-colCell': { display: 'none' },
              '& .css-1iyq7zh-MuiDataGrid-columnHeaders': { display: 'none' },
              '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': {
                  py: 0.5,
              },
              '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': {
                  py: '5px',
              },
              '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': {
                  py: '10px',
              },
          }}
          experimentalFeatures={{ lazyLoading: true }}
      />
      </div>
    </div>
  )
}

// SENT
const Sent = () => {

  return(
    <div className="inbox">
      <div className="inbox__search">
        <span className='inbox__search-span'>Sent</span>
        <div className="inbox__search-box">
          <input type="text" className="inbox__search-input" 
          placeholder='Search'/>
          <span><i class='bx bx-search'></i></span>
        </div>
      </div>

      <div className="inbox__table">
        <DataGrid
          // getRowId={(rows => rows.date)}
          rows={rows}
          columns={columns}
          initialState={{
          pagination: {
              paginationModel: {
              pageSize: 5,
              },
          },
          }}
          pageSizeOptions={[5]}
          checkboxSelection
          disableRowSelectionOnClick
          getRowHeight={() => 'auto'} 
          sx={{
              maxWidth: {md: '1100px', sm: '600px', xs: '400px'},
              '& .MuiDataGrid-colCell': { display: 'none' },
              '& .css-1iyq7zh-MuiDataGrid-columnHeaders': { display: 'none' },
              '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': {
                  py: 0.5,
              },
              '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': {
                  py: '5px',
              },
              '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': {
                  py: '10px',
              },
          }}
          experimentalFeatures={{ lazyLoading: true }}
      />
      </div>
    </div>
  )
}

// DRAFT
const Draft = () => {

  return(
    <div className="inbox">
      <div className="inbox__search">
        <span className='inbox__search-span'>Draft</span>
        <div className="inbox__search-box">
          <input type="text" className="inbox__search-input" 
          placeholder='Search'/>
          <span><i class='bx bx-search'></i></span>
        </div>
      </div>

      <div className="inbox__table">
        <DataGrid
          // getRowId={(rows => rows.date)}
          rows={rows}
          columns={columns}
          initialState={{
          pagination: {
              paginationModel: {
              pageSize: 5,
              },
          },
          }}
          pageSizeOptions={[5]}
          checkboxSelection
          disableRowSelectionOnClick
          getRowHeight={() => 'auto'} 
          sx={{
              maxWidth: {md: '1100px', sm: '600px', xs: '400px'},
              '& .MuiDataGrid-colCell': { display: 'none' },
              '& .css-1iyq7zh-MuiDataGrid-columnHeaders': { display: 'none' },
              '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': {
                  py: 0.5,
              },
              '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': {
                  py: '5px',
              },
              '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': {
                  py: '10px',
              },
          }}
          experimentalFeatures={{ lazyLoading: true }}
      />
      </div>
    </div>
  )
}

// OUTBOX
const Outbox = () => {

  return(
    <div className="inbox">
      <div className="inbox__search">
        <span className='inbox__search-span'>Outbox</span>
        <div className="inbox__search-box">
          <input type="text" className="inbox__search-input" 
          placeholder='Search'/>
          <span><i class='bx bx-search'></i></span>
        </div>
      </div>

      <div className="inbox__table">
        <DataGrid
          // getRowId={(rows => rows.date)}
          rows={rows}
          columns={columns}
          initialState={{
          pagination: {
              paginationModel: {
              pageSize: 5,
              },
          },
          }}
          pageSizeOptions={[5]}
          checkboxSelection
          disableRowSelectionOnClick
          getRowHeight={() => 'auto'} 
          sx={{
              maxWidth: {md: '1100px', sm: '600px', xs: '400px'},
              '& .MuiDataGrid-colCell': { display: 'none' },
              '& .css-1iyq7zh-MuiDataGrid-columnHeaders': { display: 'none' },
              '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': {
                  py: 0.5,
              },
              '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': {
                  py: '5px',
              },
              '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': {
                  py: '10px',
              },
          }}
          experimentalFeatures={{ lazyLoading: true }}
      />
      </div>
    </div>
  )
}

// STARRED
const Starred = () => {

  return(
    <div className="inbox">
      <div className="inbox__search">
        <span className='inbox__search-span'>Starred</span>
        <div className="inbox__search-box">
          <input type="text" className="inbox__search-input" 
          placeholder='Search'/>
          <span><i class='bx bx-search'></i></span>
        </div>
      </div>

      <div className="inbox__table">
        <DataGrid
          // getRowId={(rows => rows.date)}
          rows={rows}
          columns={columns}
          initialState={{
          pagination: {
              paginationModel: {
              pageSize: 5,
              },
          },
          }}
          pageSizeOptions={[5]}
          checkboxSelection
          disableRowSelectionOnClick
          getRowHeight={() => 'auto'} 
          sx={{
              maxWidth: {md: '1100px', sm: '600px', xs: '400px'},
              '& .MuiDataGrid-colCell': { display: 'none' },
              '& .css-1iyq7zh-MuiDataGrid-columnHeaders': { display: 'none' },
              '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': {
                  py: 0.5,
              },
              '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': {
                  py: '5px',
              },
              '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': {
                  py: '10px',
              },
          }}
          experimentalFeatures={{ lazyLoading: true }}
      />
      </div>
    </div>
  )
}

// TRASH
const Trash = () => {

  return(
    <div className="inbox">
      <div className="inbox__search">
        <span className='inbox__search-span'>Trash</span>
        <div className="inbox__search-box">
          <input type="text" className="inbox__search-input" 
          placeholder='Search'/>
          <span><i class='bx bx-search'></i></span>
        </div>
      </div>

      <div className="inbox__table">
        <DataGrid
          // getRowId={(rows => rows.date)}
          rows={rows}
          columns={columns}
          initialState={{
          pagination: {
              paginationModel: {
              pageSize: 5,
              },
          },
          }}
          pageSizeOptions={[5]}
          checkboxSelection
          disableRowSelectionOnClick
          getRowHeight={() => 'auto'} 
          sx={{
              maxWidth: {md: '1100px', sm: '600px', xs: '400px'},
              '& .MuiDataGrid-colCell': { display: 'none' },
              '& .css-1iyq7zh-MuiDataGrid-columnHeaders': { display: 'none' },
              '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': {
                  py: 0.5,
              },
              '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': {
                  py: '5px',
              },
              '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': {
                  py: '10px',
              },
          }}
          experimentalFeatures={{ lazyLoading: true }}
      />
      </div>
    </div>
  )
}


const Email = () => {
  const dispatch = useDispatch()
  const {accessToken, user} = useSelector((state)=>state.user)
  // const [accessToken, setAccessToken] = useState('');
  const [messages, setMessages] = useState([]);
  const [tabs, setTabs] = useState('inbox');
  // console.log(accessToken)

  useEffect(() => {
    const fetchAccessToken = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const accessToken = urlParams.get('access_token');
      if (accessToken) {
        // setAccessToken(accessToken);
        dispatch(storeToken(accessToken))
      }
    };
    fetchAccessToken();
  }, []);

  useEffect(()=>{
    const fetchUserMail = async ()=>{
      const res = await fetchMail(user?.token, accessToken)
      const snippet = []
      const reducedArray = res?.data?.map(message => ({
        id: message.id,
        subject: message.payload.headers.find(header => header.name === 'Subject')?.value || '',
        from: message.payload.headers.find(header => header.name === 'From')?.value || '',
        date: message.payload.headers.find(header => header.name === 'Date')?.value || '',
      }));
      setMessages(reducedArray)
      console.log(reducedArray)
    } 

    fetchUserMail()
  },[])

  const handleLogin = () => {
    window.location.href = 'https://aspom-server.onrender.com/api-v1/auth';
    // window.location.href = 'https://todolist-server-dfnz.onrender.com/api-v1/auth';
  };

  const handleFetchEmails = async () => {
    try {
      const response = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      // const response = await fetch('https://aspom-server.onrender.com/fetch-emails', {
      //   headers: {
      //     Authorization: `Bearer ${accessToken}`,
      //   },
      // });
      const emails = await response.json();
      console.log('Emails:', emails);
    } catch (error) {
      console.error('Error fetching emails:', error);
    }
  };

  const handleFetchMessages = async () => {
    try {
      const response = await fetch('https://www.googleapis.com/gmail/v1/users/me/messages?maxResults=20', {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const emails = await response.json();
      // console.log('Emails:', emails);
      
      // Extract message IDs from the response
      const messageIds = emails.messages.map(message => message.id);
      
      // Fetch each message using its ID
      const fetchMessage = async (messageId) => {
        const url = `https://www.googleapis.com/gmail/v1/users/me/messages/${messageId}`;
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        const message = await response.json();
        return message;
      };
  
      // Fetch all messages concurrently
      const promises = messageIds.map(messageId => fetchMessage(messageId));
      const messages = await Promise.all(promises);
      
      // Store the fetched messages in state
      setMessages(messages);
      
    } catch (error) {
      console.error('Error fetching emails:', error);
    }
  };

  // console.log(messages)
    

    return (
        <section className="email">
          {/* HEADING */}
          <div className="heading">
            <div className="heading__box">
                <div className="heading-item">
                    <h3 className="heading-title">Email | </h3>
                    <i class='bx bx-home heading__title-icon'></i>
                    <Link to="/" className="heading-text">
                        Home <i class='bx bx-chevron-right heading-icon'></i>
                    </Link>
                    <span className="heading-text">
                      Email <i class='bx bx-chevron-right heading-icon'></i>
                    </span>
                </div>
                <p className="heading-text">
                  Compose mail and view your inbox
                </p>
            </div>
          </div>

            <p>
              {messages}
            </p>
            {/* {accessToken ? (
              <div style={{display: 'flex', flexDirection: 'column',gap: '1rem'}}>
                <button onClick={handleFetchEmails}>Fetch Emails</button>
                <button onClick={handleFetchMessages}>Fetch Messages</button>
              </div>
            ) : (
              <button onClick={handleLogin}>Login with Google</button>
            )} */}

            {
              accessToken ? (
                <div className="email__container">

                  <div className="email__right">
                    <div className="email__right-tabs">
                      <button className={`email__right-tab ${tabs === 'inbox' && 'active'}`}
                      onClick={()=>setTabs('compose')}>
                        Compose
                      </button>
                      <button className={`email__right-tab ${tabs === 'inbox' && 'active'}`}
                      onClick={()=>setTabs('inbox')}>
                        <span>
                          <i class='bx bxs-envelope'></i>
                          Inbox
                        </span>
                        <span className='email__right-tab_count'>6</span>
                      </button>
                      <button className={`email__right-tab ${tabs === 'sent' && 'active'}`}
                      onClick={()=>setTabs('sent')}>
                        <span>
                          <i class='bx bxs-send'></i>
                          Sent
                        </span>
                      </button>
                      <button className={`email__right-tab ${tabs === 'draft' && 'active'}`}
                      onClick={()=>setTabs('draft')}>
                        <span>
                          <i class='bx bxs-envelope-open'></i>
                          Draft
                        </span>
                        <span className='email__right-tab_count'>3</span>
                      </button>
                      <button className={`email__right-tab ${tabs === 'outbox' && 'active'}`}
                      onClick={()=>setTabs('outbox')}>
                        <span>
                          <i class='bx bx-share'></i>
                          Outbox
                        </span>
                      </button>
                      <button className={`email__right-tab ${tabs === 'starred' && 'active'}`}
                      onClick={()=>setTabs('starred')}>
                        <span>
                          <i class='bx bxs-star'></i>
                          Starred
                        </span>
                        <span className='email__right-tab_count'>2</span>
                      </button>
                      <button className={`email__right-tab ${tabs === 'trash' && 'active'}`}
                      onClick={()=>setTabs('trash')}>
                        <span>
                          <i class='bx bxs-trash'></i>
                          Trash
                        </span>
                        <span className='email__right-tab_count'>9</span>
                      </button>
                      
                    </div>
                    <div className="email__right-tabs">
                      <div className="email__right-tabs_heading">
                          <div className="email__right-tabs_header">
                            <h4 className="email__right-tabs_title">Labels</h4>
                            <button className="email__right-tabs_heading-btn">
                              <i class='bx bx-plus'></i>
                            </button>
                          </div>
                          {/* <div className="email__right-tabs_collapse"></div> */}
                      </div>
                    </div>
                  </div>

                  <div className="email__left">
                    {tabs === 'compose' && <ComposeMail/>}
                    {tabs === 'inbox'  && <Inbox messagesRows={messages}/>}
                    {tabs === 'sent'  && <Sent/>}
                    {tabs === 'draft'  && <Draft/>}
                    {tabs === 'outbox'  && <Outbox/>}
                    {tabs === 'starred'  && <Starred/>}
                    {tabs === 'trash'  && <Trash/>}
                  </div>
                </div>
              ) : (
                <div className="email__invalid">
                    <div className="email__auth-content">
                        <button className="email__auth-button"
                        onClick={handleLogin}>
                          <img src={googleImg} alt="Google logo"
                          className="email__auth-logo"/>
                            Continue with google
                        </button>
                    </div>
                </div>
              )
            }


        </section>
    )
}

export default Email